module.exports = __webpack_public_path__ + "img/Breezy Software designed by Landscape Logo-05.e0e3decc.png";